export default "__VITE_ASSET__kMklFSX7__"